// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WLTX","largestCol":"styles_largestCol__2y8ML","smallestCol":"styles_smallestCol__3K-4O"};